import { useSelector } from 'react-redux';

import {
  ISG_TREND_COMPONENT_TYPES,
  ISG_PERFORMANCE_VIEW,
} from '../../../../../utils/constants';
import { TrendChip } from '../Accordion/TrendChip';
import { PrimaryMetricsLayout } from '../shared/PrimaryMetricsLayout';
import { roundToTwoDecimals } from '../../utils';
import { selectShowPercent } from '../../../../../selectors/settings';
import s from './PerformancePrimaryMetrics.module.css';
import sharedStyles from '../shared/PrimaryMetricsLayout.module.css';

export const PerformancePrimaryMetrics = ({
  isAccordionOpen = false,
  pointsEarned,
  pointsPossible,
  currentGrade,
  isMobile = false,
  assignmentsCompleted,
  assignmentsPossible,
  missedAssignmentsSinceLastWeek,
  possibleAssignmentsSinceLastWeek,
  changeInGrade,
}) => {
  const showPercent = useSelector(selectShowPercent);

  const hasAssignmentsSinceLastWeek = possibleAssignmentsSinceLastWeek > 0;
  const shouldShowTrendChip = !isMobile && hasAssignmentsSinceLastWeek;

  const studentPoints = roundToTwoDecimals(pointsEarned);
  const assignedPoints = roundToTwoDecimals(pointsPossible);
  const gradePercentage = `${roundToTwoDecimals(currentGrade * 100)}%`;
  const gradeAsPoints = `${studentPoints}/${assignedPoints} pts`;

  let primaryTotal = gradeAsPoints;
  let secondaryTotal = gradePercentage;

  if (showPercent) {
    primaryTotal = gradePercentage;
    secondaryTotal = gradeAsPoints;
  }

  const scoreMetricContent = (
    <>
      <div className={s.primary}>{primaryTotal} </div>
      <div className={s.secondary}>
        {'course total ('}
        {secondaryTotal}
        {')'}
      </div>
      {shouldShowTrendChip && changeInGrade !== null && (
        <TrendChip
          value={roundToTwoDecimals(changeInGrade * 100)}
          type={ISG_TREND_COMPONENT_TYPES.SCORE}
          currentView={ISG_PERFORMANCE_VIEW}
        />
      )}
    </>
  );

  const activitiesMetricContent = (
    <>
      <span className={s.primary}>
        {assignmentsCompleted} / {assignmentsPossible}
      </span>
      <div className={s.totalLabel}>activities completed</div>
      {shouldShowTrendChip && missedAssignmentsSinceLastWeek !== null && (
        <TrendChip
          value={missedAssignmentsSinceLastWeek}
          type={ISG_TREND_COMPONENT_TYPES.UNCOMPLETED_ACTIVITIES}
          currentView={ISG_PERFORMANCE_VIEW}
        />
      )}
    </>
  );

  return (
    <PrimaryMetricsLayout
      isAccordionOpen={isAccordionOpen}
      scoreMetricContent={scoreMetricContent}
      activitiesMetricContent={activitiesMetricContent}
      showDivider={true}
      dividerHeightClass={sharedStyles.dividerSlice2}
    />
  );
};

export default PerformancePrimaryMetrics;
